import { useEffect, useRef } from "react"
import { getCable } from "../../../../shared/api/cable"

export const useSystemNoticeSocket = ({ onScheduled, onExecuting }) => {
  const handlersRef = useRef({ onScheduled, onExecuting })
  handlersRef.current = { onScheduled, onExecuting }

  useEffect(() => {
    const subscription = getCable().subscriptions.create(
      { channel: "SystemNoticeChannel" },
      {
        received(data) {
          const { onScheduled, onExecuting } = handlersRef.current
          if (data.type === "scheduled") onScheduled?.(data.notice)
          if (data.type === "executing") onExecuting?.(data)
        },
      }
    )

    return () => subscription.unsubscribe()
  }, [])
}

export default useSystemNoticeSocket
